

















































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
const log = NSLog("view/ManageBundles");

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import FontPlugin from "@ckeditor/ckeditor5-font/src/font";
import BundleHelpers, { Bundle } from "@/models/bundle";
import { Package } from "@/models/package";
import { search as SearchPackage } from "@/dialogs/package";

@Component({
  components: {
    loader,
    SearchPackage
  }
})
export default class EditPackageDialog extends Vue {
  @Prop({ required: true }) public value!: Bundle;
  @Prop({ required: true }) public packages!: Package[];

  public editor = ClassicEditor;
  public editorConfig = {
    plugins: [
      EssentialsPlugin,
      BoldPlugin,
      ItalicPlugin,
      ParagraphPlugin,
      FontPlugin
    ],

    toolbar: {
      items: ["bold", "italic", "undo", "redo", "fontSize"]
    }
  };

  private loading = false;
  valid = false;
  private bundle: Bundle = BundleHelpers.New();
  showSearch = false;

  public created() {
    this.bundle =
      this.value
        ? Object.assign({}, this.value)
        : BundleHelpers.New();
  }

  get shortCodes() {
    return this.bundle.package_short_codes || [];
  }

  get bundlePackages() {
    if (!this.bundle) return [];
    return this.shortCodes.map((sCode: string) => {
      return this.packages.find((p) => p.short_code && p.is_visible_now && p.short_code == sCode)
    })
  }

  get bundlePrice() {
    if (!this.bundlePackages) return 0;
    return this.bundlePackages.reduce((v: number, bp: any) => v + bp.price, 0)
  }

  addPackage(pkg: Package | false) {
    if (pkg && pkg.short_code) {
      this.bundle.package_short_codes = [...this.shortCodes, pkg.short_code];
    }
    this.showSearch = false;
  }
  removePackage(pkg: Package) {
    this.bundle.package_short_codes = this.shortCodes.filter((pc) => pc !== pkg.short_code);
  }

  async updateBundle() {
    this.loading = true
    console.log("updating bundle:", this.bundle);
    const newBundle = await billingApi.updateBundle(this.bundle);
    this.loading = true
    this.$emit('input', newBundle);
  }

  public headers = [
    { text: "Code", value: "code" },
    {
      text: "Title",
      align: "left",
      sortable: true,
      value: "title"
    },

    { text: "Interval", value: "interval" },
    { text: "Price", value: "price" },
    // { text: "Currency", value: "currency" },
    // { text: "Updated", value: "updated_at" },

    { text: "Cart Description", value: "description" },
    { text: "Invoice Description", value: "long_description" },

    { text: "", value: "" }
  ];
}
